<template>
	<div class="parameter">
		<div class="container">
			<div class="content">
				
					<p>产品参数</p>
					<div class="list">
						<p>尺寸大小：</p><p class="one"></p>
						<p>材质：</p><p class="one"></p>
					</div>	
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'parameter'
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
.parameter{
	width: 70%;
	.content{
		padding: 15px;
		p{
			width: 70%;
			height: 40px;
			text-align: center;
			line-height: 40px;
			color: #FFFFFF;
			background: #00A0FF;
		}
		.list{
			width: 70%;
			border: 1px solid #ccc;
			p{
				width: 25%;
				border-right: 1px solid #CCCCCC;
				border-bottom: 1px solid #CCCCCC;
				display: inline-block;
				height: 40px;
				/*border: 1px solid #ccc;*/
				background: #FFFFFF;
				color: #000;
				margin-top: 0;
				text-align: right;
			}
			.one{
				width: 75%;
				height: 40px;
				float: right;
				/*display: inline-block;*/
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProductCenter/PDcom/Parameter.vue